import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteEventDeliveryAddressMutationVariables = Types.Exact<{
  delivery_address_id: Types.Scalars['ID'];
}>;


export type DeleteEventDeliveryAddressMutation = { __typename?: 'Mutation', deleteEventDeliveryAddress: string };


export const DeleteEventDeliveryAddressDocument = gql`
    mutation DeleteEventDeliveryAddress($delivery_address_id: ID!) {
  deleteEventDeliveryAddress(delivery_address_id: $delivery_address_id)
}
    `;
export type DeleteEventDeliveryAddressMutationFn = Apollo.MutationFunction<DeleteEventDeliveryAddressMutation, DeleteEventDeliveryAddressMutationVariables>;

/**
 * __useDeleteEventDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useDeleteEventDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventDeliveryAddressMutation, { data, loading, error }] = useDeleteEventDeliveryAddressMutation({
 *   variables: {
 *      delivery_address_id: // value for 'delivery_address_id'
 *   },
 * });
 */
export function useDeleteEventDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventDeliveryAddressMutation, DeleteEventDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventDeliveryAddressMutation, DeleteEventDeliveryAddressMutationVariables>(DeleteEventDeliveryAddressDocument, options);
      }
export type DeleteEventDeliveryAddressMutationHookResult = ReturnType<typeof useDeleteEventDeliveryAddressMutation>;
export type DeleteEventDeliveryAddressMutationResult = Apollo.MutationResult<DeleteEventDeliveryAddressMutation>;
export type DeleteEventDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<DeleteEventDeliveryAddressMutation, DeleteEventDeliveryAddressMutationVariables>;